"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DialogAction = (function () {
    function DialogAction(label, handler, appearance) {
        if (appearance === void 0) { appearance = 'default'; }
        this.label = label;
        this.handler = handler;
        this.appearance = appearance;
    }
    return DialogAction;
}());
exports.default = DialogAction;
//# sourceMappingURL=dialog-action.js.map